import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import styles from './styles.module.scss';

const EncyclopediaBreadcrumbs = ({ paths }) => (
  <div className={styles.encyclopediaBreadcrumbs}>
    {paths.map((path, index) =>
      path.link ? (
        <span>
          <Link to={path.link}>{path.title}</Link>
          <FontAwesomeIcon size="sm" icon="chevron-right" className="ml-2" />
        </span>
      ) : (
        <span>{path.title}</span>
      ),
    )}
  </div>
);

export default EncyclopediaBreadcrumbs;
